export default function onlyPhone(phoneNumber) {
  return phoneNumber.replace(/\D/g, '');
}
